var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9991 2.47063C13.9919 2.34839 13.9401 2.23303 13.8535 2.14644C13.767 2.05985 13.6516 2.00805 13.5294 2.00085C8.75976 1.72006 4.94085 3.15817 3.31235 5.84707C2.74771 6.76895 2.46959 7.83776 2.51324 8.91793C2.54878 9.91523 2.83969 10.9219 3.37724 11.9156L9.64645 5.64645C9.74024 5.55278 9.86738 5.50018 9.99993 5.50022C10.1325 5.50027 10.2596 5.55294 10.3533 5.64667C10.4471 5.7404 10.4997 5.86751 10.4998 6.00006C10.4998 6.13261 10.4472 6.25975 10.3535 6.35354L4.08435 12.6228C5.07803 13.1603 6.08475 13.4512 7.08206 13.4867C7.15188 13.4892 7.22125 13.4905 7.29053 13.4905C8.30062 13.4933 9.29164 13.2154 10.1529 12.6877C12.8418 11.0591 14.2797 7.23965 13.9991 2.47063Z",
    fill: "#45B150"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57127 12.2573C3.50307 12.1436 3.43895 12.0297 3.37725 11.9156L2.14647 13.1464C2.05269 13.2402 2.00001 13.3674 2 13.5C1.99999 13.6326 2.05267 13.7598 2.14643 13.8536C2.2402 13.9473 2.36738 14 2.49999 14C2.6326 14 2.75978 13.9474 2.85356 13.8536L4.08436 12.6228C3.97033 12.5611 3.85642 12.497 3.74278 12.4288C3.67239 12.3866 3.61349 12.3277 3.57127 12.2573Z",
    fill: "#45B150"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLeaf);
export default __webpack_public_path__ + "static/media/ic_leaf.9c6b50c8.svg";
export { ForwardRef as ReactComponent };